import * as adminsApi from '@/api/admins/admins'
import * as auth from '@/utils/auth'
import i18n from '@/lang/i18n'

const admins = {
  state: {
    session: auth.getSession(),
    roles: [],
    uid: '',
    avatar: 'img/avatars/man.png',
    locale: i18n.locale
  },
  mutations: {
    SET_SESSION: (state, session) => {
      state.session = session
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_UID: (state, uid) => {
      state.uid = uid
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_LANG: (state, locale) => {
      state.locale = locale
      i18n.locale = locale
      localStorage.setItem('locale', locale)
    }
  },
  actions: {
    login ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.login(data).then(res => {
          if (res.code === 2000) {
            commit('SET_SESSION', res.data[0].session)
            auth.setSession(res.data[0].session)
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        adminsApi.logout().then(res => {
          if (res.code === 2000) {
            commit('SET_SESSION', '')
            commit('SET_ROLES', [])
            commit('SET_UID', '')
            commit('SET_AVATAR', 'img/avatars/man.png')
            commit('SET_LANG', i18n.locale)
            auth.removeSession()
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

    checkSession ({ commit }) {
      return new Promise((resolve, reject) => {
        adminsApi.checkSession().then(res => {
          if (res.code === 2000) {
            commit('SET_ROLES', res.data[0].roles)
            commit('SET_UID', res.data[0].id)
            commit('SET_AVATAR', res.data[0].avatar ? res.data[0].avatar : 'img/avatars/man.png')
            if (res.data[0].locale && res.data[0].locale !== i18n.locale) {
              location.reload()
            }
            commit('SET_LANG', res.data[0].locale ? res.data[0].locale : i18n.locale)
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

    updateAdminProfile ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.updateAdminProfile(data).then(res => {
          if (res.code === 2000) {
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

    updateAdminLocale ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.updateAdminLocale(data).then(res => {
          if (res.code === 2000) {
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

    updateAdminPassword ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.updateAdminPassword(data).then(res => {
          if (res.code === 2000) {
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

    updateAdminAvatar ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.updateAdminAvatar(data).then(res => {
          if (res.code === 2000) {
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

    getAdmins ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.getAdmins(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

    showAdmin ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.showAdmin(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },

    storeAdmin ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.storeAdmin(data).then(res => {
          if (res.code === 2000) {
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

    updateAdmin ({ commit }, data) {
      return new Promise((resolve, reject) => {
        adminsApi.updateAdmin(data).then(res => {
          if (res.code === 2000) {
            resolve()
          } else {
            reject(res.message)
          }
        })
      })
    },

  }
}

export default admins
